import { render, staticRenderFns } from "./PazienteAllegatiEditComponent.vue?vue&type=template&id=ec3f8f04"
import script from "./PazienteAllegatiEditComponent.vue?vue&type=script&lang=js"
export * from "./PazienteAllegatiEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports